import { render, staticRenderFns } from "./ListOwnerChanged.vue?vue&type=template&id=0fce752c&scoped=true&"
import script from "./ListOwnerChanged.vue?vue&type=script&lang=js&"
export * from "./ListOwnerChanged.vue?vue&type=script&lang=js&"
import style0 from "./ListOwnerChanged.vue?vue&type=style&index=0&id=0fce752c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fce752c",
  null
  
)

export default component.exports